import {
  USER_UPDATE,
  USER_UPDATE_LANGUAGE,
  USER_SIGN_OUT,
} from './actions';

export default function(state = { token: null, enrollmentPage: 25 }, action) {
  switch (action.type) {
    case USER_UPDATE:
      return { ...state, ...action.payload };
    case USER_UPDATE_LANGUAGE:
      return { ...state, info: { ...state.info, language: action.payload } };
    case USER_SIGN_OUT:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user/index.js